var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tree && _vm.tab == 'interactive')?_c('div',[_c('TreeViewInteractive',{attrs:{"tree":_vm.tree,"decisionId":_vm.decisionId,"decisionName":_vm.decisionName}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }